import { render, staticRenderFns } from "./ModalAPIErrors.vue?vue&type=template&id=3215c6a8"
import script from "./ModalAPIErrors.vue?vue&type=script&lang=js"
export * from "./ModalAPIErrors.vue?vue&type=script&lang=js"
import style0 from "./ModalAPIErrors.vue?vue&type=style&index=0&id=3215c6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports